import React from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { Button } from '../../../../components';

import css from './SectionHero.css';
import { createResourceLocatorString } from '../../../../util/routes';
import routeConfiguration from '../../../../routeConfiguration';
import classNames from 'classnames';

const SectionHero = ({ history }) => (
    <section className={css.root}>
        <div className={css.content}>
            <h1 className={css.subHeading}>Matching-Algorithmus</h1>
            <p
                className={css.superHeading}
            >{`Tschüss Nadel im Heuhaufen. \nHallo transparente Suche!`}</p>
            <p className={css.description}>
                {`Wir haben einen Matching-Algorithmus entwickelt, der es dir \nkinderleicht macht, das perfekte Match für dich oder dein Pferd zu finden.`}
            </p>
        </div>
        <footer className={css.footer}>
            <Button
                className={css.subLinkPrimary}
                type="button"
                onClick={() =>
                    history.push(createResourceLocatorString('SignupPage', routeConfiguration()))
                }
            >
                Kostenlos registrieren
            </Button>
            <Button
                onClick={() => {
                    const node = document.getElementById('kriterien');
                    node && node.scrollIntoView({ block: 'center', behavior: 'smooth' });
                }}
                className={classNames(css.noBounce, css.subLinkSecondary)}
            >
                Kriterien
            </Button>
        </footer>
    </section>
);

export default compose(withRouter)(SectionHero);
